// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import { spacing, fontSize, fontWeight } from 'presentations/views/styles';
import { black, primary } from 'presentations/views/styles/color';
import Dialog from 'presentations/views/components/atoms/Dialog';
import Icon from 'presentations/views/components/atoms/Icon';
import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';
import { ReactNode, SyntheticEvent, useState } from 'react';
import Link from '../../atoms/Link';
import TextArea from '../../atoms/TextArea';

interface Props {
  isOpen: boolean;
  onSubmit: (e: any, isSendUpdates: boolean, message?: string) => void;
  isLoading?: boolean;
  onCancel?: any;
  submitField?: ReactNode | null;
}

export default function Component(props: Props) {
  const [message, setMessage] = useState('');
  const t = translateInComponent(translations);

  const onChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    setMessage(value);
  };

  return (
    <Dialog isOpen={props.isOpen}>
      <Title>{t('title')}</Title>
      <SubTitle>{t('textArea title')}</SubTitle>
      <TextAreaWrap
        isAutoFocus={false}
        isFullWidth
        name={`message`}
        value={message}
        placeholder={t('placeholder')}
        onChange={onChange}
      />
      <DialogSubmitField
        isLoading={props.isLoading}
        onSubmit={(e: SyntheticEvent) => props.onSubmit(e, true, message)}
        onCancel={props.onCancel}
        submitLabel={t('submit')}
        cancelLabel={t('cancel')}
      />
      <PageLinkContainer>
        <LinkIcon name="chevron-right" />
        <PageLink onClick={(e: SyntheticEvent) => props.onSubmit(e, false)}>
          {t("Don't send")}
        </PageLink>
      </PageLinkContainer>
    </Dialog>
  );
}

const Title = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  margin-bottom: ${spacing(16)};
  text-align: center;
  white-space: pre-wrap;
`;
const SubTitle = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(16)};
  margin-top: ${spacing(24)};
  margin-bottom: ${spacing(12)};
`;
const TextAreaWrap = styled(TextArea)`
  margin-bottom: ${spacing(24)};
`;
const PageLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacing(20)};
  font-size: ${fontSize(13)};
`;
const LinkIcon = styled(Icon)`
  color: ${primary};
  width: 18px !important;
  height: 18px !important;
  margin-right: ${spacing(4)};
`;
const PageLink = styled(Link)`
  color: ${black};
`;
